import useFeatureExperimentalCheck from 'web/hooks/useFeatureExperimentalCheck';
import { To } from 'history';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import themeConstants from 'web/styles/themeConstants';
import themeVars from 'web/styles/themeVars.css';

const DashboardNavContainer = styled.nav`
  ${themeConstants.typography.h1};

  display: flex;
  flex-wrap: wrap;

  margin-top: 52px;
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: bold;

  ${themeConstants.media.sm} {
    margin-bottom: 15px;
  }

  ${themeConstants.media.lg} {
    font-size: 32px;
    line-height: 140%;
  }

  ${themeConstants.media.xl} {
    font-size: 36px;
  }

  > :not(:last-child) {
    margin-right: 20px;
  }
`;

const DashboardNavLink = styled(NavLink)`
  ${themeConstants.mixins.nonTextLink};

  white-space: nowrap;

  color: ${themeVars.color.halfMuted};
  text-decoration: underline;
  text-decoration-style: dotted;

  &.active {
    color: unset;
    text-decoration: unset;
  }
`;

type DashboardNavItem = {
  text: string;
  to: To;
  end?: boolean;
  feature?: keyof introwise.ExperimentalFeatureFlags;
};

const DashboardNavItemComponent = ({ item }: { item: DashboardNavItem }) => {
  // Always call the hook, passing undefined if no feature
  const featureEnabled = useFeatureExperimentalCheck(item.feature);
  if (!featureEnabled) return null;
  return (
    <DashboardNavLink to={item.to} end={item.end}>
      {item.text}
    </DashboardNavLink>
  );
};

const DashboardNav = ({ items }: { items: DashboardNavItem[] }) => (
  <DashboardNavContainer>
    {items.map((item, idx) => (
      <DashboardNavItemComponent item={item} key={idx} />
    ))}
  </DashboardNavContainer>
);

export default DashboardNav;
